import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from './auth.service';
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
@Injectable()
export class ServiceProviderAuthGuard implements CanActivate {

    constructor(private router: Router, private authService: AuthService,
        @Inject(PLATFORM_ID) private platformId: Object) { }

    canActivate(parameter) {
        if (isPlatformBrowser(this.platformId)) {
        const userrole = this.authService.getRoleId();
        if (localStorage.getItem('token') && userrole == 3) {
            // logged in so return true
            return true;
        }else if(localStorage.getItem('token') && userrole == 2) {
        // not logged in so redirect to login page
        this.router.navigate(['/signin']);
        return false;
        }else {
            this.router.navigate(['/serviceproviderlogin']); 
            return false; 
        }
    }
    }
}